<template>
    <div class="my_treat_page">
        <div class="name_info">
            <div class="name_num">
                <span class="left">{{detailinfo.name}}</span>
                <span class="right" v-if="detailinfo.appointmentnum">{{detailinfo.appointmentnum}}</span>
            </div>
            <div class="account_info">
                <div class="sex_age_phone">
                    <span>{{detailinfo.sex}} . {{detailinfo.age}}岁</span>
                    <span v-if="detailinfo.phone">{{detailinfo.phone}}</span>
                </div>
                <div class="account">
                    <span>工号：{{dispname}}</span>
                </div>
            </div>

        </div>
        <div class="main_info">
            <div class="info_line">
                <span>开单医生</span>
                <p>{{detailinfo.doctor  || '--'}}</p>
            </div>
            <div class="info_line">
                <span>预约时间</span>
                <p>{{detailinfo.appointmenttime}}</p>
            </div>
            <div class="info_line">
                <span>理疗名称</span>
                <p :class="'status'+detailinfo.execstatuscode">{{detailinfo.projectname}}，{{detailinfo.execstatusname}}</p>
            </div>
            <div class="info_line">
                <span>医生备注</span>
                <p>{{detailinfo.doctorremark || '--'}}</p>
            </div>
            <div class="info_line">
                <span>执行人</span>
                <p>{{detailinfo.execdoctorname}}</p>
            </div>
            <div class="info_line">
                <span>执行诊室</span>
                <p>{{detailinfo.roomname}}</p>
            </div>
            <div class="info_line">
                <span>执行时间</span>
                <p>{{detailinfo.exectime}}</p>
            </div>
            <div class="info_line" v-if="detailinfo.feeaccount">
                <span>扣费账号</span>
                <p class="status2">{{detailinfo.feeaccount}}</p>
            </div>
            <div class="info_line">
                <span>理疗备注</span>
                <p>{{detailinfo.treatremark || '--'}}</p>
            </div>
            <div class="info_line">
                <span>配穴方案</span>
                <div>{{detailinfo.acupointdesc || '--'}}</div>
            </div>
        </div>
        <div class="btn_detail_info">
            <div class="btn_div" @click="medical">
                <i class="icon iconfont iconbingli"></i>
                <p>患者病历</p>
            </div>
            <div class="btn_div" @click="treat">
                <i class="icon iconfont iconyoujian"></i>
                <p>理疗记录</p>
            </div>
            <div class="btn_div" @click="check">
                <i class="icon iconfont iconshijian"></i>
                <p>检查历史</p>
            </div>
        </div>

        <div class="exec_list" v-if="execlist.length > 0">
            <div class="exec_th">
                <span>理疗名称</span>
                <span>执行人</span>
                <span>执行状态</span>
                <span>操作</span>
            </div>
            <div class="one" v-for="item in execlist" :key="item.id">
                <div class="exec_td">
                    <span>{{item.projectname}}</span>
                    <span>{{item.execdoctorname}} {{item.isown == '1' ? '(本人)': '(他人)'}}</span>
                    <span :class="'status' + item.execstatuscode">{{item.execstatusname}}</span>
                    <span v-if="item.execstatuscode === 2 || item.execstatuscode === 3" @click="match(item.id,item.execstatuscode, item.acupointids)">配穴</span>
                    <span v-else>--</span>
                </div>
            </div>
        </div>

         <div class="ctrl_bottom" v-if="show">
             <button @click="back">返回</button>
             <button @click="cancelProject" v-if="detailinfo.execstatuscode === '2' || detailinfo.execstatuscode === '3'">取消执行</button>
             <button @click="again" v-if="detailinfo.execstatuscode === '2' || detailinfo.execstatuscode === '3'">重新分诊</button>
             <button class="exec_class" @click="nowExec" v-if="detailinfo.execstatuscode === '2'" >立即执行</button>
             <button class="exec_class" @click="finish" v-if="detailinfo.execstatuscode === '3'">完成</button>
        </div>
        
    </div>
</template>

<script>
    import { wxtreatdetail,wxtreatopr } from '@/api/medical'
    import { mapGetters } from 'vuex'
    import { Toast } from 'vant'
    export default {
        computed: {
            ...mapGetters([
                'username','dispname'
            ]),
        },
        data() {
            return {
                execstatus: '0',
                serviceid: '',
                doctor:'',
                roomid:'',
                doctorname: '',
                detailinfo: {},
                execlist:[],
                userid: '',
                customerid:'',
                name:'',
                sex:'',
                age:'',
                phone:'',
                show: true
            }
        },
        mounted () {
            this.$store.dispatch('hideOrShowNav', false)
            this.serviceid = this.$route.query.serviceid || ''
            this.getDetailInfo()
        },
        methods: {
            // 获取订单信息
            getDetailInfo(){
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                })
                let data = {
                    username: this.username,
                    serviceid: this.serviceid
                }
                wxtreatdetail(data).then(response => {
                    Toast.clear()
                    this.detailinfo = response.response_body
                    this.execlist = response.response_body.execlist
                    this.execstatus = response.response_body.execstatuscode
                    this.doctor = response.response_body.execdoctorcode
                    this.roomid = response.response_body.roomid
                    this.doctorname = response.response_body.execdoctorname
                    this.name = response.response_body.name
                    this.sex = response.response_body.sex
                    this.age = response.response_body.age
                    this.phone = response.response_body.phone
                    this.userid = response.response_body.userid
                    this.customerid = response.response_body.customerid
                })
            },
            //返回
            back() {
                this.$router.go(-1)
            },
            // 取消执行
            cancelProject(){
                this.$dialog.confirm({
                    title: null,
                    message: '确认取消本次分诊操作？',
                })
                .then(() => {
                    let data = {
                        username: this.username,
                        oprtype: '0',
                        serviceid: this.serviceid
                    }
                    wxtreatopr(data).then(() => {
                        this.$store.dispatch('changeIsRefresh', '1')
                        Toast.success('已成功取消本次分诊!');
                        this.show = false
                        let second = 2;
                        const timer = setInterval(() => {
                            second--;
                            if (second === 0) {
                                clearInterval(timer);
                                this.$router.go(-1)
                            }
                        }, 1000);

                    })
                })
                .catch(() => {
                    // on cancel
                });
            },
            // 立即执行
            nowExec(){
                this.$dialog.confirm({
                    title: null,
                    message: '确认执行本次项目操作？',
                })
                    .then(() => {
                        let data = {
                            username: this.username,
                            oprtype: '2',
                            serviceid: this.serviceid
                        }
                        wxtreatopr(data).then(() => {
                            this.$store.dispatch('changeIsRefresh', '1')
                            Toast.success('已执行成功!');
                            this.show = false
                            let second = 2;
                            const timer = setInterval(() => {
                                second--;
                                if (second === 0) {
                                    clearInterval(timer);
                                    location.reload()
                                }
                            }, 1000);

                        })
                    })
                    .catch(() => {
                        // on cancel
                    });
            },
            //重新分诊
            again() {
                this.$router.push({
                    path: '/treatExec',
                    query: {
                        serviceid: this.serviceid,
                        oprtype: '1',
                        doctor: this.doctor,
                        roomid: this.roomid,
                        doctorname: this.doctorname
                    }
                })
            },
            //完成
            finish() {
                this.$router.push({
                    path: '/treatExec',
                    query: {
                        serviceid: this.serviceid,
                        oprtype: '3',
                        doctor: this.doctor,
                        roomid: this.roomid,
                        doctorname: this.doctorname
                    }
                })
            },
            medical() {
                this.$router.push({
                    path: '/medicalPage',
                    query: {
                        userid: this.userid,
                        customerid: this.customerid
                    }
                })
            },
            treat() {
                this.$router.push({
                    path: '/historyPage',
                    query: {
                        userid: this.userid,
                        customerid: this.customerid,
                        name: this.name,
                        sex: this.sex,
                        age: this.age,
                        phone: this.phone
                    }
                })
            },
            check() {
                this.$router.push({
                    path: '/checkPage',
                    query: {
                        userid: this.userid,
                        customerid: this.customerid,
                        name: this.name,
                        sex: this.sex,
                        age: this.age,
                        phone: this.phone
                    }
                })
            },
            match(id, execstatus, acupointids) {
                this.$router.push({
                    path: '/matchAcupoint',
                    query: {
                        serviceid: id,
                        userid: this.userid,
                        customerid: this.customerid,
                        name: this.name,
                        sex: this.sex,
                        age: this.age,
                        phone: this.phone,
                        execstatus: execstatus,
                        acupointids: acupointids,
                    }
                })
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>